/* SIEMPREVIVA · comportamiento de las secciones sv- */
(function () {
  'use strict';

  function euros(centimos) {
    var e = Math.floor(centimos / 100), c = centimos % 100;
    return e + (c ? ',' + (c < 10 ? '0' : '') + c : '') + ' €';
  }

  /* Aparición suave al hacer scroll */
  function aparecer() {
    var els = document.querySelectorAll('.sv-aparece:not(.is-visible)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Galería: deslizar en móvil, miniaturas en ordenador */
  function galerias() {
    document.querySelectorAll('[data-sv-galeria]').forEach(function (g) {
      if (g.dataset.listo) return; g.dataset.listo = '1';
      var pista = g.querySelector('.sv-galeria__pista');
      var botones = g.querySelectorAll('.sv-galeria__miniaturas button, .sv-galeria__puntos button');
      if (!pista) return;
      function ir(i) { pista.scrollTo({ left: i * pista.clientWidth, behavior: 'smooth' }); }
      botones.forEach(function (b) { b.addEventListener('click', function () { ir(+b.dataset.i); }); });
      var t;
      pista.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(pista.scrollLeft / pista.clientWidth);
          botones.forEach(function (b) { b.setAttribute('aria-current', +b.dataset.i === i ? 'true' : 'false'); });
        }, 60);
      });
      g.irA = ir;
    });
  }

  /* Caja de compra: acabado (variante) + oferta por cantidad */
  function compras() {
    document.querySelectorAll('[data-sv-compra]').forEach(function (f) {
      if (f.dataset.listo) return; f.dataset.listo = '1';
      var datos = JSON.parse(f.querySelector('[data-sv-variantes]').textContent);
      var idInput = f.querySelector('input[name="id"]');
      var precioEl = document.querySelectorAll('[data-sv-precio-actual]');
      function actualizar() {
        var acabado = f.querySelector('input[name="sv-acabado"]:checked');
        var oferta = f.querySelector('input[name="quantity"]:checked');
        var v = datos.filter(function (x) { return !acabado || x.opcion === acabado.value; })[0] || datos[0];
        idInput.value = v.id;
        var boton = f.querySelector('button[type="submit"]');
        boton.disabled = !v.disponible;
        var txt = boton.querySelector('[data-sv-boton-texto]');
        if (txt) txt.textContent = v.disponible ? boton.dataset.texto : 'Agotado';
        f.querySelectorAll('[data-sv-oferta-precio]').forEach(function (el) {
          var q = +el.dataset.cantidad, desc = +(el.dataset.descuento || 0);
          el.textContent = euros(v.precio * q - desc);
        });
        precioEl.forEach(function (el) { el.textContent = euros(v.precio); });
        var total = f.querySelector('[data-sv-total]');
        if (total && oferta) total.textContent = euros(v.precio * (+oferta.value) - (+(oferta.dataset.descuento || 0)));
        if (acabado && v.imagen != null) {
          var g = document.querySelector('[data-sv-galeria]');
          if (g && g.irA) g.irA(v.imagen);
        }
      }
      f.addEventListener('change', actualizar);
      actualizar();
    });
  }

  /* Barra fija en móvil: aparece cuando la caja de compra sale de la pantalla */
  function barra() {
    var b = document.querySelector('[data-sv-barra]');
    var caja = document.querySelector('[data-sv-compra-principal]');
    if (!b || !caja || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      var fuera = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      b.classList.toggle('is-visible', fuera);
    }).observe(caja);
  }

  function iniciar() { aparecer(); galerias(); compras(); barra(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
